import { render, staticRenderFns } from "./a-radio-button.vue?vue&type=template&id=4590794a&"
import script from "./a-radio-button.vue?vue&type=script&lang=js&"
export * from "./a-radio-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports